import {VIR} from "./tenants/VIR/config";
import {MDM} from "./tenants/MDM/config";
import {AGR} from "./tenants/AGR/config";
import {FIC} from "./tenants/FIC/config";
import {SAM} from "./tenants/SAM/config";

export const DOMAINS = {
    "localhost": MDM,

    "recat-vir-dev.firebaseapp.com": VIR,
    "vinitaly.8preview.it": VIR,
    "vinitalyplus.com": VIR,

    "recat-mdm-dev.firebaseapp.com": MDM,
    "marmomac.8preview.it": MDM,
    "marmomacplus.com": MDM,

    "recat-agr-dev.veronafiere.ozwol.tech": AGR,
    "fieragricola.8preview.it": AGR,
    "catalogo.fieragricola.it": AGR,

    "recat-fic-dev.veronafiere.ozwol.tech": FIC,
    "fieracavalli.8preview.it": FIC,
    "catalogo.fieracavalli.it": FIC,

    "recat-sam-dev.veronafiere.ozwol.tech": SAM,
    "samoter.8preview.it": SAM,
    "catalogo.samoter.it": SAM,
};
